import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

import { IdUtils, UaService } from '@ecm/consumer';
import { EcmRouterModule, Link, LinkService, RouterService, ToggleService, TrackingData } from '@ecm/router';
import { KenobiParams, Status } from '@ecm/tracker';

import { SuggestedContractViewModel } from '../../../../business/model/crossroads/contracts-options/suggested-contract.view-model';
import { KenobiCodes } from '../../../../business/model/tracking/kenobiCodes';
import { TrackedPage } from '../../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../../services/tracking.service';
import { ParamsUtils } from '../../../../utils/params.utils';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
    selector: 'contract-suggested',
    templateUrl: 'contract-suggested.html',
    styleUrls: ['contract-suggested.css'],
    standalone: true,
    imports: [NgClass, AsyncPipe, EcmRouterModule, TranslateModule],
})
export class ContractSuggestedComponent extends AbstractComponent implements OnInit {
    @Input()
    public viewModel: SuggestedContractViewModel;

    @Input()
    public borderBottom = false;

    /**
     * Transaction properties for BCO monitoring
     */
    private readonly pageId: string;

    public readonly ParamsUtils = ParamsUtils;

    public ecmAddContractStatus: boolean;

    private suggestedContractTranslation: any;

    public constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
        private readonly translate: TranslateService,
        private readonly trackingService: TrackingService,
        private readonly linkService: LinkService,
        private readonly toggleService: ToggleService,
    ) {
        super(uaService, routerService);
        this.pageId = IdUtils.generateRandomId();
    }

    public ngOnInit(): void {
        super.ngOnInit();
        this.suggestedContractTranslation = this.translate.instant('dashboard.contractsAndOptions.suggestedContract');
        this.toggleService
            .getFeatureStatus('DASHBOARD.ADD_CONTRACT_ECM')
            .pipe(take(1))
            .subscribe((ecmAddContractStatus) => (this.ecmAddContractStatus = ecmAddContractStatus));
    }

    public getAddSuggestedContractLink(): Link {
        return this.suggestedContractTranslation.addContract[this.ecmAddContractStatus ? 'ecmLink' : 'link'];
    }

    /**
     * Route to add suggested contract page
     */
    public addSuggestContract(): void {
        this.trackingService.trackKenobi(
            new KenobiParams(KenobiCodes.CRATTRAP['functionality'], KenobiCodes.CRATTRAP['rubric'], Status.OK),
            this.pageId,
        );
        this.linkService.openLink(
            this.getAddSuggestedContractLink(),
            Object.assign(new TrackingData(), {
                tmsTracking: {
                    trackedPage: TrackedPage.contractsAndOptions,
                    trackingArea: 'care_selecteurcontrat_rapproche',
                    trackingName: this.suggestedContractTranslation.addContract['button'],
                },
            }),
            ParamsUtils.cidMap(this.viewModel.cid),
        );
    }

    /**
     * Route to remove suggested contract page
     */
    public removeSuggestedContract(): void {
        this.linkService.openLink(
            this.suggestedContractTranslation.removeContract['link'],
            Object.assign(new TrackingData(), {
                tmsTracking: {
                    trackedPage: TrackedPage.contractsAndOptions,
                    trackingArea: 'care_selecteurcontrat_rapproche',
                    trackingName: this.suggestedContractTranslation.removeContract['button'],
                },
            }),
            ParamsUtils.cidMap(this.viewModel.cid),
        );
    }
}
